export const IS_PRERENDER =
  (typeof window !== 'undefined' && window.__PRERENDER__ === true) ||
  (typeof process !== 'undefined' &&
    !!process.env &&
    process.env.PRERENDER === 'true');

export default IS_PRERENDER;
